import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { FinalProductService } from 'src/app/private/services/final-product.service';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { UserDto } from 'src/app/shared/dto/user.dto';

@Component({
    selector: 'app-modal-edit-raw-material-from-final-product',
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzModalFooterDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzMessageModule,
        NzFormModule,
        NzButtonModule
    ],
    templateUrl: './modal-edit-raw-material-from-final-product.component.html',
    styleUrl: './modal-edit-raw-material-from-final-product.component.scss'
})
export class ModalEditRawMaterialFromFinalProductComponent implements OnInit {
    @Output() emitService = new EventEmitter();

    id: number = 0;
    rawMaterial: RawMaterialDto = new RawMaterialDto();
    data = inject(NZ_MODAL_DATA);
    currentUser: UserDto = new UserDto();
    validateForm: FormGroup<{
        quantity: FormControl<number>;
    }>;
    isSaving: boolean = false;

    readonly userLoggedService = inject(UserLoggedService);
    readonly finalProductService = inject(FinalProductService);
    readonly message = inject(NzMessageService);
    readonly fb = inject(NonNullableFormBuilder);
    private readonly modalRef = inject(NzModalRef);

    constructor(){
        this.validateForm = this.fb.group({
            quantity: [0, [Validators.required, Validators.min(0)]]
        });
    }

    async ngOnInit() {
        this.currentUser = this.userLoggedService.userLogged;
        this.rawMaterial = {
            id: this.data.rawMaterial.id ?? undefined,
            article: this.data.rawMaterial.article ?? undefined,
            articleBatch: this.data.rawMaterial.articleBatch ?? undefined,
            rawQuantity: this.data.rawMaterial.quantity
        };
        this.id = this.data.id;
        this.validateForm.patchValue(this.data.rawMaterial);
    }


    async submitForm(): Promise<void> {
        try {
            this.isSaving = true;

            if (!this.validateForm.valid) {
                this.isSaving = false;
                this.message.error(`Porfavor, rellene los campos obligatorios`);
                return;
            }

            this.rawMaterial.rawQuantity = this.validateForm.controls.quantity.value;

            const rawMaterialUpdated: RawMaterialDto = await this.finalProductService.updateRawMaterialQuantityFromFinalProduct(this.rawMaterial);
            this.isSaving = false;
            this.message.success(`Materia prima actualizada correctamente`);

            this.emitService.emit(rawMaterialUpdated);
            this.modalRef.close();
        } catch (e: unknown) {
            this.isSaving = false;
            if (e instanceof Error) {
                this.message.error(e.message);
            }
        }
    }

    handleCancel() {
        this.modalRef.close();
    }

}
